export const ADD_SCRAPER_DATA = 'scraper/ADD_SCRAPER_DATA'
